import { createContext } from "react";

import type { PrimeEventEmitterType } from "~/clientState/providers/generic/PrimeEventManager/types/PrimeEventEmitterType";
import type {
  EventEmitterCatalog,
  PrimeEventData,
} from "~/clientState/providers/generic/PrimeEventManager";

const PrimeEventEmitterContext = createContext<PrimeEventEmitterType>({
  eventEmitterHook:
    (id: EventEmitterCatalog) =>
    (data: PrimeEventData): void => {
      // do nothing
    },
});

export default PrimeEventEmitterContext;
